import Axios from 'axios';
import { getAccessToken } from './helper';
import PackageJson from "../package.json";
import { localData, sessionData } from "@/services/helper";

export const API_URL = window.location.origin == "http://localhost:3000" ? process.env.API_LOCAL_URL : process.env.API_DEV_URL;
export const axiosBase = Axios.create({ baseURL: API_URL });
const CLIENT_VERSION = PackageJson.version || '1.0';

axiosBase.interceptors.request.use(
    async config => {
        config.headers['x-client-platform'] = 'Web';
        config.headers['x-client-version'] = CLIENT_VERSION;
        const accessToken = getAccessToken();
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;

    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle auth errors globally
axiosBase.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error && error.response) {
            const status = error.response.status;
            if (status === 401 || status === 403) {
                try {
                } catch (e) { }
            }
            if (status === 410) {
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
);

export const errorHandler = (error: any) => {
    if (typeof error?.response?.data === "string" && /<\/?[a-z][\s\S]*>/i.test(error?.response?.data)) {
        return { errorMessage: error.response?.statusText ?? "Something went wrong" }
    } else if (error.response) {
        return error.response.data
    } else if (error.message) {
        return { errorMessage: error.message }
    } else if (error?.response?.statusText) {
        return { errorMessage: error.response.statusText }
    } else {
        return { errorMessage: "Something went wrong" }
    }
}

export const setAuthToken = (response : any) => {
    const localUser: any = localData.get("AUTHDATA");
    const sessionUser: any = sessionData.get("AUTHDATA");
    if (localUser?.id === response.userId || sessionUser?.id === response.userId) {
        console.log('Setting auth token in setAuthToken12323:', response.token);
        const updatedUser = {
            ...localUser,
            token: response.token,
            subscriptionStatus: response.status,
        }
        localData.set("AUTHDATA", updatedUser);
        sessionData.set("AUTHDATA", updatedUser);
    }
    return null
}

